var _defs, _circle, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "RAR Loading",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#007bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8c00"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 58,
    stroke: "url(#grad)",
    strokeWidth: 6,
    fill: "none",
    strokeDasharray: "90 40"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 70 70",
    to: "360 70 70",
    dur: "1.2s",
    repeatCount: "indefinite"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 60        H52        L60 66        L76 54        L84 60        H100",
    fill: "none",
    stroke: "#FF5A00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 120,
    strokeDashoffset: 120
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 120,
    to: 0,
    dur: "1.2s",
    repeatCount: "indefinite"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 82,
    textAnchor: "middle",
    fontSize: 8,
    fontWeight: 700,
    fill: "#FF5A00",
    fontFamily: "Arial, Helvetica, sans-serif",
    opacity: 0
  }, "\n        RAJA ALAM RAYA\n\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "0.3s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 6",
    to: "0 0",
    dur: "0.6s",
    begin: "0.3s",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.fa940bf8d79b4bfb02ef553afa8bca74.svg";
export { ForwardRef as ReactComponent };